import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useCallback, useState } from "react";

import {
  BLACK,
  dateFormatText,
  GRAY_DARK,
  GRAY_DARKEST,
  GREEN,
  RED,
  YELLOW
} from "../../../../constants";

import { AdhocAgreement } from "integrity-owls-logic/dist";
import moment from "moment-timezone";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import AdhocAgreementsTableHeader from "./Header";

const useStyles = makeStyles(theme => ({
  approvedStatusText: {
    color: GREEN
  },
  buttonSpan: {
    "&:hover": {
      cursor: "pointer"
    },
    padding: "10px",
    fontWeight: "bold"
  },
  pendingStatusText: {
    color: YELLOW
  },
  deniedStatusText: {
    color: RED
  },
  paper: {
    backgroundColor: "transparent",
    width: "100%",
    marginBottom: theme.spacing(2),
    boxShadow: "none"
  },
  table: {
    minWidth: 750
  },
  tableCell: {
    backgroundColor: GRAY_DARKEST,
    border: "none",
    borderBottom: "10px solid " + BLACK
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer"
    }
  },
  tableWrapper: {
    overflowX: "auto"
  },
  workIdText: {
    paddingLeft: "20px",
    fontSize: "20px",
    color: GRAY_DARK,
    fontStyle: "italic"
  }
}));

interface AdhocAgreementsTableProps {
  agreements: any[];
  loading: boolean;
}

const NoResultsRow = () => {
  return (
    <TableRow tabIndex={-1}>
      <TableCell align="center">No Results</TableCell>
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
    </TableRow>
  );
};

export const AdhocAgreementsTable: React.FC<AdhocAgreementsTableProps> = ({
  agreements,
  loading
}) => {
  const history = useHistory();
  const classes = useStyles();
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");

  const handleSortRows = useCallback(
    (property: string) => {
      const newDirection = sortDirection === "asc" ? "desc" : "asc";
      setSortBy(property);
      setSortDirection(newDirection);
    },
    [sortDirection]
  );

  const renderActionButton = (agreement: AdhocAgreement) => {
    const newClassName = "";
    const buttonText = "View";
    // switch (status) {
    //   case "APPROVED":
    //   case "ACTIVE":
    //     newClassName = classes.approvedStatusText;
    //     break;
    //   case "STARTED":
    //   case "PENDING":
    //   case "UPDATE_NEEDED":
    //   case "UPDATE_MADE":
    //     newClassName = classes.pendingStatusText;
    //     break;
    //   case "DENIED":
    //     newClassName = classes.deniedStatusText;
    //     break;
    //   default:
    //     break;
    // }
    return (
      <Box>
        <Link to={`/adhoc-agreements/${agreement.id}`}>
          <span className={`${newClassName} ${classes.buttonSpan}`}>
            {buttonText}
          </span>
        </Link>
      </Box>
    );
  };

  const renderTableBody = () => {
    if (loading) {
      return <CircularProgress />;
    }
    if (agreements.length < 1) {
      return <NoResultsRow />;
    }
    return (
      <TableBody>
        {agreements.map((agreement, index) => {
          return (
            <TableRow
              hover
              tabIndex={-1}
              key={agreement.id}
              className={classes.tableRow}
              onClick={() => {
                history.push(`/adhoc-agreements/${agreement.id}`);
              }}
            >
              <TableCell className={classes.tableCell} align="left">
                {agreement.id}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {agreement.licenseeName}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {agreement.songTitles}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {agreement.dateIssued
                  ? moment(agreement.dateIssued)
                      .tz("GMT")
                      .format(dateFormatText)
                  : "not recorded"}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {agreement.dateExecuted
                  ? moment(agreement.dateExecuted)
                      .tz("GMT")
                      .format(dateFormatText)
                  : "not recorded"}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {agreement.paymentDueDate
                  ? moment(agreement.paymentDueDate)
                      .tz("GMT")
                      .format(dateFormatText)
                  : "not recorded"}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {agreement.datePaid
                  ? moment(agreement.datePaid).tz("GMT").format(dateFormatText)
                  : "not recorded"}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {agreement.status}
              </TableCell>
              <TableCell className={classes.tableCell} align="left">
                {renderActionButton(agreement)}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  return (
    <Paper className={classes.paper}>
      <div className={classes.tableWrapper}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <h2>Agreements</h2>
          {/* <span className={classes.workIdText}>{work.id}</span> */}
        </Box>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size="small"
          aria-label="enhanced table"
        >
          <AdhocAgreementsTableHeader
            handleSortRows={handleSortRows}
            sortBy={sortBy}
            sortDirection={sortDirection}
          />
          {renderTableBody()}
        </Table>
      </div>
    </Paper>
  );
};
